export const APP_BAR_MOBILE = 64;
export const APP_BAR_DESKTOP = 70;

export const APP_BAR_DESKTOP_PLUS_PADDING_TOP = APP_BAR_DESKTOP + 8;
export const APP_BAR_MOBILE_PLUS_PADDING_TOP = APP_BAR_MOBILE + 14;

export const DEVICE_PROFILE_TITLE_CARD = 140;
export const DEVICE_PROFILE_TITLE_CARD_WITHOUT_BACK = 141;
export const BASE_SPACING = 8;
export const TABS_HEIGHT = 40;
